import React from 'react';
import { Table, TableBody, TableCell, TableRow } from '@mui/material';
import { getFormattedCellValue, tableStyles } from './details-table-helpers';

interface ObjectTableProps {
    value: object;
    label?: string;
}

const ObjectBasedTableRow = ({
    label,
    value,
}: ObjectTableProps): React.JSX.Element => {
    return (
        <TableRow key={label}>
            {label && <TableCell sx={tableStyles.colorKey}>{label}</TableCell>}
            <TableCell sx={tableStyles.colorValue}>
                <Table sx={tableStyles.innerTable}>
                    <TableBody>
                        {Object.keys(value).map((innerKey) => {
                            let cellValue;
                            if (
                                innerKey === 'errorLogBase64' ||
                                innerKey === 'consoleBase64'
                            ) {
                                cellValue = atob(
                                    value[innerKey as keyof typeof value]
                                );
                            } else {
                                cellValue =
                                    value[innerKey as keyof typeof value];
                            }
                            return (
                                <TableRow key={`${label}_${innerKey}`}>
                                    <TableCell sx={tableStyles.nestedColorKey}>
                                        {innerKey}
                                    </TableCell>
                                    <TableCell
                                        sx={tableStyles.nestedColorValue}
                                    >
                                        {getFormattedCellValue(cellValue)}
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableCell>
        </TableRow>
    );
};

export default ObjectBasedTableRow;
